import React, { useState, useCallback, useContext, useRef } from "react";
import { useLocation } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import { Zap, ZapOff } from "lucide-react";
import { Scanner } from "@yudiel/react-qr-scanner";
import "../../../assets/css/Customer/CustomerSettings/CustomerScanner.css";
import CustomerSettingsMasterLayout from "../../../layouts/Customer/CustomerSettingsMasterLayout";
import axios from "axios";
import AppContext from "../../../context/AppContext";
const CustomerScanner = () => {
  const location = useLocation();
  const { baseUrl, authToken } = useContext(AppContext);
  const totalCoins = location.state?.totalCoins || 0;

  const [flashOn, setFlashOn] = useState(false);
  const [cameraActive, setCameraActive] = useState(false);
  const [scanStatus, setScanStatus] = useState("");
  const [loading, setLoading] = useState(false);
  const [coinsToSend, setCoinsToSend] = useState(totalCoins);
  const scanningRef = useRef(false);


  const stopCamera = useCallback(() => {
    setCameraActive(false);
    setFlashOn(false);
    setScanStatus("");
  }, []);

  const handleScan = async (results) => {
    if (scanningRef.current) return;
    if (!results || results.length === 0) return;
    const driverId = results[0]?.rawValue;

    alert("Scanned: " + driverId);
    if (!driverId) return;
    scanningRef.current = true;
    setLoading(true);

    const formData = new FormData();
    formData.append("tddriver_id", driverId);
    formData.append("coins", coinsToSend);

    axios
      .post(`${baseUrl}/customer/customerwallet/transferCoins`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${authToken}`,
        },
      })
      .then((response) => {
        if (response.data.success === true) {
          console.log("Response:", response.data)
          console.log("coin transferred", response.data);

          setScanStatus("Coins Transferred Successfully!");
          stopCamera();
        } else {
          setScanStatus("Failed: " + response.data.message);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setScanStatus("Network Error! Please try again.");
        setLoading(false);
      });
  };

  const handleStartCamera = useCallback(() => {
    setCameraActive(true);
  }, []);

  return (
    <CustomerSettingsMasterLayout
      screenName={"CustomerScanner"}
      centered={true}
    >
      <div className="CustomerScanner-wrapper">
        {/* ── ACTIVE CAMERA VIEW ── */}
        <div
          className={`CustomerScanner-fullscreen-camera ${cameraActive ? "CustomerScanner-fullscreen-camera--active" : "CustomerScanner-fullscreen-camera--hidden"}`}
        >
          {cameraActive && (
            <Scanner
              onScan={handleScan}
              torch={flashOn}
              components={{ finder: false }}
              styles={{
                container: {
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  zIndex: 2,
                },
                video: {
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                },
              }}
            />
          )}

          {/* Header */}
          <div className="CustomerScanner-camera-header">
            <div
              className="CustomerScanner-camera-back-btn"
              onClick={stopCamera}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path
                  d="M19 12H5M5 12l7 7M5 12l7-7"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>

            <h5 className="CustomerScanner-camera-title">Scan QR Code</h5>

            <div
              className="CustomerScanner-camera-flash-btn"
              onClick={() => setFlashOn((prev) => !prev)}
            >
              {flashOn ? (
                <Zap
                  size={22}
                  className="CustomerScanner-flash-icon--on"
                  strokeWidth={2.5}
                />
              ) : (
                <ZapOff
                  size={22}
                  className="CustomerScanner-flash-icon--off"
                  strokeWidth={2.5}
                />
              )}
            </div>
          </div>

          {/* Coins Badge */}
          <div className="CustomerScanner-coins-badge">
            🪙 {coinsToSend} Coins will be transferred
          </div>

          {/* Scan Frame */}
          <div className="CustomerScanner-center-frame">
            <div className="CustomerScanner-scan-box">
              <div className="CustomerScanner-corner CustomerScanner-corner-tl">
                <span className="CustomerScanner-corner-dot tl" />
              </div>
              <div className="CustomerScanner-corner CustomerScanner-corner-tr">
                <span className="CustomerScanner-corner-dot tr" />
              </div>
              <div className="CustomerScanner-corner CustomerScanner-corner-bl">
                <span className="CustomerScanner-corner-dot bl" />
              </div>
              <div className="CustomerScanner-corner CustomerScanner-corner-br">
                <span className="CustomerScanner-corner-dot br" />
              </div>
              <div className="CustomerScanner-scan-line-wrap">
                <div className="CustomerScanner-scan-line" />
              </div>
            </div>
            <p className="CustomerScanner-scan-instruction">
              {loading
                ? "Processing..."
                : scanStatus || "Align the Driver's QR code within the frame"}
            </p>
          </div>
        </div>

        {/* ── INACTIVE / START VIEW ── */}
        {!cameraActive && (
          <Container className="CustomerScanner-container">
            <div className="CustomerScanner-camera-area">
              <div className="CustomerScanner-camera-preview">
                <div className="CustomerScanner-camera-feed">
                  <div className="CustomerScanner-camera-icon-wrap">
                    <div className="CustomerScanner-camera-icon-ring">
                      <svg
                        width="40"
                        height="40"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"
                          stroke="rgba(27,155,130,0.8)"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <circle
                          cx="12"
                          cy="13"
                          r="4"
                          stroke="rgba(27,155,130,0.8)"
                          strokeWidth="1.5"
                        />
                      </svg>
                    </div>
                    <span className="CustomerScanner-camera-hint">
                      TAP TO ACTIVATE
                    </span>
                  </div>
                </div>
                <div className="CustomerScanner-scan-frame">
                  <div className="CustomerScanner-corner CustomerScanner-corner-tl" />
                  <div className="CustomerScanner-corner CustomerScanner-corner-tr" />
                  <div className="CustomerScanner-corner CustomerScanner-corner-bl" />
                  <div className="CustomerScanner-corner CustomerScanner-corner-br" />
                  <div className="CustomerScanner-scan-line-wrap">
                    <div className="CustomerScanner-scan-line" />
                  </div>
                </div>
              </div>
            </div>

            <div className="CustomerScanner-bottom-content">
              <div className="CustomerScanner-instructions">
                <h6 className="CustomerScanner-instruction-title">
                  Scan Driver's QR Code
                </h6>
                <p className="CustomerScanner-instruction-text">
                  Align the QR code within the frame to exchange coins instantly
                </p>
              </div>

              {/* Coins Info Box */}
              <div className="CustomerScanner-coins-info">
                <span>
                  🪙 Your Coins: <strong>{totalCoins}</strong>
                </span>
                <p>Enter coins to transfer to driver</p>
              </div>

              {/*  NEW: Coins Input */}
              <div className="CustomerScanner-coins-input-wrap">
                <label className="CustomerScanner-coins-label">
                  Coins to Transfer
                </label>
                <div className="CustomerScanner-input-row">
                  <button
                    className="CustomerScanner-qty-btn"
                    onClick={() =>
                      setCoinsToSend((prev) => Math.max(0, prev - 1))
                    }
                  >
                    −
                  </button>
                  <input
                    type="number"
                    className="CustomerScanner-qty-input"
                    value={coinsToSend}
                    min={0}
                    max={totalCoins}
                    onChange={(e) => {
                      const val = Number(e.target.value);
                      setCoinsToSend(val > 0 ? val : 1);
                    }}
                  />
                  <button
                    className="CustomerScanner-qty-btn"
                    onClick={() => setCoinsToSend((prev) => prev + 1)}
                  >
                    +
                  </button>
                </div>
              </div>

              <button
                className="CustomerScanner-scan-btn"
                onClick={handleStartCamera}
                disabled={loading || coinsToSend === 0}
              >
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                  <rect
                    x="3"
                    y="3"
                    width="5"
                    height="5"
                    rx="1"
                    stroke="white"
                    strokeWidth="2"
                  />
                  <rect
                    x="16"
                    y="3"
                    width="5"
                    height="5"
                    rx="1"
                    stroke="white"
                    strokeWidth="2"
                  />
                  <rect
                    x="3"
                    y="16"
                    width="5"
                    height="5"
                    rx="1"
                    stroke="white"
                    strokeWidth="2"
                  />
                  <path
                    d="M16 16h2v2h-2zM18 18h3v3h-3zM16 21h2"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </svg>
                <span>Scan to Exchange {coinsToSend} Coins</span>{" "}

              </button>

              <div className="CustomerScanner-info-card">
                <Row className="align-items-center">
                  <Col xs="auto">
                    <div className="CustomerScanner-info-icon">
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <circle
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="#1B9B82"
                          strokeWidth="2"
                        />
                        <path
                          d="M12 8v4M12 16h.01"
                          stroke="#1B9B82"
                          strokeWidth="2"
                          strokeLinecap="round"
                        />
                      </svg>
                    </div>
                  </Col>
                  <Col>
                    <div className="CustomerScanner-info-text">
                      <p className="mb-0">
                        Scan the driver's QR code to transfer coins instantly.
                        Make sure the code is clearly visible and well-lit.
                      </p>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </Container>
        )}
      </div>
    </CustomerSettingsMasterLayout>
  );
};

export default CustomerScanner;
